module.exports = __webpack_public_path__ + "img/sleeve binding width.a28e3d95.png";